import { FC, useEffect, useState } from "react";
import { LoadingStatus } from "../../../@types/enumsGlobal";
import { DefaultGrid } from "../../../components/grids/default/defaultGrid";
import { PluginWrapper } from "../../../components/plugins";
import useGridFilter, { DefaultGridFilter } from "../../../system/hooks/useGridFilter";
import { useAppContext } from "../../../system/providers/appContextProvider";
import { GoodsGroupDataProvider } from "../../../Services/DataProviders/GoodsGroupDataProvider";
import { IGoodsGroupViewByGoodViewDTO } from "../../../libs/coreapi-dto/dirs/goodsGroup";
import { usePluginContext } from "../../../system/providers/plugin";

export const GoodsGroupByGoodGrid: FC<IGridProps> = (props) => {
    const appCtx = useAppContext();
    const pluginCtx = usePluginContext();
    const goodsGroupADP = new GoodsGroupDataProvider(appCtx.coreApiService);

    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.NoData);
    const [data, setData] = useState<IGoodsGroupViewByGoodViewDTO[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [viewState, setViewState] = useState<GridStateType>("view");
    const [gridFilter, dispatchGridFilter] = useGridFilter(DefaultGridFilter);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [selectedItems, setSelectedItems] = useState<IGridRow[]>(props.data ?? []);
    

    useEffect(() => {
        if (pluginCtx.masterGrid.selectedItem) {
            goodsGroupADP.getViewByIdGood(pluginCtx.masterGrid.selectedItem?.idGlobal as string, gridFilter, (data, totalCount) => {
                setData(data);
                setTotalCount(totalCount)
                data.length > 0 ? setLoadingStatus(LoadingStatus.Completed) : setLoadingStatus(LoadingStatus.NoData)
            });
        }
    }, [pluginCtx.masterGrid.selectedItem?.idGlobal, gridFilter]);

    return (
        <PluginWrapper>
            <DefaultGrid
                gridId={props.gridId}
                singleDirectory
                data={data}
                loadingStatus={loadingStatus}
                setLoadingStatus={setLoadingStatus}
                filter={gridFilter}
                getView={(gridFilter, callback) => {
                    goodsGroupADP.getViewByIdGood(pluginCtx.masterGrid.selectedItem?.idGlobal as string, gridFilter, (entities) => {
                        callback(entities)
                        setSelectedItem(undefined);
                    })
                }}
                totalCount={totalCount}
                dataProvider={goodsGroupADP}
                selectedItem={selectedItem}
                selectedItems={selectedItems}
                onSelect={(row) => {
                    setSelectedItem(row)
                    props.onSelect?.(row)
                }}
                onMultipleSelect={(rows) => {
                    setSelectedItems(rows)
                    props?.onMultipleSelect?.(rows)
                }}
                multipleSelect={props.multipleSelect}
                plugin={props.plugin}
                onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
                onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                onEnter={() => setViewState("edit")}
            />
        </PluginWrapper>
    )
}